var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "single-choice-settings" } }, [
    _c("div", { staticClass: "form-field" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "field-label" } },
        [_vm._v(_vm._s(_vm.$t("form.fieldLabel")))]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.fieldLabel,
            expression: "fieldLabel",
          },
        ],
        staticClass: "form-input",
        attrs: {
          type: "text",
          id: "field-label",
          placeholder: "Bir soru girin",
        },
        domProps: { value: _vm.fieldLabel },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.fieldLabel = $event.target.value
            },
            function ($event) {
              return _vm.setFieldLabel(_vm.fieldLabel)
            },
          ],
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [
        _vm._v(_vm._s(_vm.$t("form.labelAlignment"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "button-group" }, [
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.labelAlign === "left" },
            on: {
              click: function ($event) {
                return _vm.setlabelAlign("left")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("form.left")) + "\n            ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.labelAlign === "right" },
            on: {
              click: function ($event) {
                return _vm.setlabelAlign("right")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("form.right")) + "\n            ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.labelAlign === "top" },
            on: {
              click: function ($event) {
                return _vm.setlabelAlign("top")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("form.top")) + "\n            ")]
        ),
      ]),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v(_vm._s(_vm.$t("form.chooseLabelAlignment"))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [
        _vm._v(_vm._s(_vm.$t("form.required"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "toggle" }, [
        _c(
          "span",
          {
            staticClass: "toggle-option",
            class: { active: _vm.isRequired },
            on: { click: _vm.toggleRequired },
          },
          [
            _vm._v(
              _vm._s(
                _vm.isRequired
                  ? _vm.$t("chatWindow.open")
                  : _vm.$t("chatWindow.closed")
              )
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v(_vm._s(_vm.$t("form.fieldEmptyError"))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [_vm._v("Görünürlük")]),
      _vm._v(" "),
      _c("div", { staticClass: "toggle" }, [
        _c(
          "span",
          {
            staticClass: "toggle-option",
            class: { active: _vm.visibility },
            on: { click: _vm.toggleVisibility },
          },
          [_vm._v(_vm._s(_vm.visibility ? "Görünür" : "Gizli"))]
        ),
      ]),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v("Bu alanın form üzerinde görünür olup olmayacağını belirler"),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label", attrs: { for: "slug-input" } }, [
        _vm._v("URL Parametresi"),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.slug,
            expression: "slug",
          },
        ],
        staticClass: "form-input",
        attrs: { type: "text", id: "slug-input", placeholder: "singleChoice" },
        domProps: { value: _vm.slug },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.slug = $event.target.value
            },
            function ($event) {
              return _vm.setSlug($event.target.value)
            },
          ],
        },
      }),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v("URL parametrelerinde kullanılacak benzersiz tanımlayıcı"),
      ]),
    ]),
    _vm._v(" "),
    _vm.items && _vm.items.length > 0
      ? _c("div", { staticClass: "form-field" }, [
          _c("label", { staticClass: "form-label" }, [_vm._v("Default Seçim")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "default-selection-list" },
            [
              _vm._l(_vm.items, function (option, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "default-option-item" },
                  [
                    _c("input", {
                      attrs: {
                        type: "radio",
                        id: "default-option-" + index,
                        name: "defaultSelection",
                      },
                      domProps: {
                        value: option,
                        checked: _vm.defaultValue === option,
                      },
                      on: {
                        change: function ($event) {
                          return _vm.setDefaultValue(option)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "default-option-" + index } }, [
                      _vm._v(_vm._s(option)),
                    ]),
                  ]
                )
              }),
              _vm._v(" "),
              _c("div", { staticClass: "default-option-item" }, [
                _c("input", {
                  attrs: {
                    type: "radio",
                    id: "default-option-none",
                    name: "defaultSelection",
                  },
                  domProps: { value: null, checked: _vm.defaultValue === null },
                  on: {
                    change: function ($event) {
                      return _vm.setDefaultValue(null)
                    },
                  },
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "default-option-none" } }, [
                  _vm._v("Seçim Yok"),
                ]),
              ]),
            ],
            2
          ),
          _vm._v(" "),
          _c("small", { staticClass: "form-description" }, [
            _vm._v(
              "Form açıldığında varsayılan olarak seçili gelecek seçeneği belirleyin"
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }